module.exports = __webpack_public_path__ + "img/news_post_3.4fc5801d.png";